module.exports = __webpack_public_path__ + "img/android.f93e505d.svg";